import { render, staticRenderFns } from "./DieCareDataTable.vue?vue&type=template&id=3fdd6f9a&scoped=true"
import script from "./DieCareDataTable.vue?vue&type=script&lang=js"
export * from "./DieCareDataTable.vue?vue&type=script&lang=js"
import style0 from "./DieCareDataTable.vue?vue&type=style&index=0&id=3fdd6f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdd6f9a",
  null
  
)

export default component.exports